import React, { PureComponent } from 'react'
import moment from 'moment'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import messages from 'i18n/messages'
import flowRight from 'lodash/flowRight'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { createStructuredSelector } from 'reselect'
import { setStatus } from 'logic/payment'
import Countdown, { zeroPad } from 'react-countdown'

class ExpiresAtCountdown extends PureComponent {

  state = {
    endCountdown: false
  }

  checkExpired = tick => this.setState({ endCountdown: tick <= 0 })

  hasExpired = () =>
    !moment(this.props.date).isValid() || moment(this.props.date) < moment() || this.state.endCountdown

  setExpired = () => this.props.actions.setStatus('expired')
  
  renderer = ({ minutes, seconds, completed }) =>
    completed
      ? <span>ABGELAUFEN!</span>
      : <span>{zeroPad(minutes)}:{zeroPad(seconds)}</span>

  render() {
    if (this.hasExpired()) {
      this.props.actions.setStatus('expired')
      return (
        <FormattedMessage {...messages.orderExpired} />
      );
    }

    return (
      <span>
        <Countdown
          date={this.props.date}
          renderer={this.renderer}
          zeroPadTime={2}
          onComplete={this.setExpired}
        /> min
      </span>
    );
  }
}

const mapStateToProps = createStructuredSelector({
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    setStatus,
  }, dispatch)
})

const enhance = flowRight(
  connect(mapStateToProps, mapDispatchToProps)
)

ExpiresAtCountdown.propTypes = {
  date: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired
}

export default enhance(ExpiresAtCountdown)
